// Three-way ordering key for the senior favorites gallery, by the garment classifier's
// attire category (poses.yearbook_attire):
//
//   band 0 — yearbook-formal (tuxedo / black_drape) AND unclassified (nil)
//   band 1 — cap & gown
//   band 2 — everything else (street_clothes / other)
//
// nil rides in band 0 on purpose: it mirrors the fail-open eligibility rule
// (an unclassified pose is pickable for the yearbook, so it must not be demoted).
// A pose already saved as THE yearbook pose always leads, regardless of attire, so an
// existing selection never sinks under a later re-classification.
export const YEARBOOK_ATTIRE = ['tuxedo', 'black_drape'];

export default function yearbookBand(pose, selectedYearbookId = null) {
  if (pose.id != null && pose.id === selectedYearbookId) return 0;

  const attire = pose.yearbookAttire;
  if (!attire || YEARBOOK_ATTIRE.includes(attire)) return 0;
  if (attire === 'cap_and_gown') return 1;
  return 2;
}
